// @flow
import { useEffect, useState } from 'react'
import { device } from '../breakpoints'
import {
  getArticleTeaserData,
  ArticleData,
} from '@ta-interaktiv/react-article-teasers'
import styled from 'styled-components'

/**
 * Dynamic inline teaser Function.
 * This function allows to render one or several article teasers.
 *
 * @param {string} title The title displayed on the bloc containing the teasers. "Lire aussi:" is the default value.
 * @param {string[]} ids The list of articles' ids.
 */
export const ArticleTeaser = ({
  title = 'Lire aussi:',
  ids,
  color = null,
  tenant
}: {
  title?: string
  ids: string[]
  color: string | null
  tenant: string
}) => {
  const [articles, setArticles] = useState(
    new Map<string | number, ArticleData>()
  )

  useEffect(() => {
    setArticles(new Map<string | number, ArticleData>())
  }, [ids])

  useEffect(() => {
    if (articles.size === 0) {
      ids.forEach((id) => {
        getArticleTeaserData(tenant, id).then((articleTeaserData: ArticleData) => {
          if (articleTeaserData) {
            setArticles(
              (articles) => new Map(articles.set(id, articleTeaserData))
            )
          }
        })
      })
    }
  }, [articles])

  return (
    <>
      {articles.size > 0 && (
        <Container>
          <Header>{title}</Header>
          <List>
            {[...articles.values()].map((article: ArticleData) => (
              <TeaserContainer
                key={`article-teaser-${article.id}`}
                href={article.url}
              >
                <ImageContainer>
                  <Image alt='' src={article.imageSrc} />
                </ImageContainer>
                <Content>
                  <ArticleHeader>
                    {article.isPremium && <Abo>ABO</Abo>}
                    {article.titleHeader}
                  </ArticleHeader>
                  <ArticleTitle>{article.title}</ArticleTitle>
                </Content>
              </TeaserContainer>
            ))}
          </List>
        </Container>
      )}
    </>
  )
}


const Container = styled.div`
  display: block;
  font-family: var(--font-sans-serif);
`
const Header = styled.div`
  line-height: 1.15em;
  font-weight: 800;
  padding-bottom: 1em;
  font-size: 1em;
`
const List = styled.div`
  padding-bottom: 1.5rem;
`
const ImageContainer = styled.div`
  width: 100%;
  max-width: 145px;
  height: auto;
  margin-right: 1em;
  overflow: hidden;
  position: relative;

  &:after {
    content: '';
    display: block;
    padding-bottom: 56%;
  }

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    margin-bottom: 0;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    margin-bottom: 0.25em;
  }
`
const Image = styled.img`
  width: 100%;
  height: auto;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
`
const Content = styled.div`
  font-size: 1em;
`
const ArticleHeader = styled.div`
  font-size: 0.75em;
  line-height: 1.3em;
  font-weight: bold;
  color: #5a64a8;
`
const ArticleTitle = styled.div`
  font-size: 0.9em;
  line-height: 1.4em;
  margin-top: 0.1em;
`
const Abo = styled.span`
  display: inline-block;
  font-size: 0.65em;
  line-height: 1.25em;
  padding: 0.3em 0.5em 0.12em;
  background-color: #5a64a8;
  color: #fff;
  margin-right: 0.65em;
`
const TeaserContainer = styled.a`
  display: flex;
  // padding: 0 0 0 1em;
  // border-left: 3px solid #c8c8d1;
  margin-bottom: 1em;
  color: white;
  text-decoration: none;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    flex-direction: row;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    flex-direction: row;
  }
`

export default ArticleTeaser
